const Navbar= ()=>{
    return(
        <div className="navbar">
            <h1>Fresh Forecast</h1>
            <p>Accurate weather forecast details in a few clicks...</p>
        </div>
    );
};

export default Navbar;